import { animatePulse } from "@/src/utils/animation.utils";
import React, { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

const PostDetailSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View style={{ opacity }}>
      {/* Header */}
      <View className="flex-row items-center px-4 py-3 border-b border-ash-3">
        <View className="w-10 h-10 rounded-full bg-ash-3 mr-3" />
        <View className="flex-1">
          <View className="h-3 w-32 bg-ash-3 rounded mb-2" />
          <View className="h-2 w-20 bg-ash-3 rounded" />
        </View>
        <View className="w-6 h-6 rounded-full bg-ash-3" />
      </View>

      {/* Content */}
      <View className="px-4 pt-3 pb-2">
        <View className="h-3 w-full bg-ash-3 rounded mb-2" />
        <View className="h-3 w-full bg-ash-3 rounded mb-2" />
        <View className="h-3 w-2/3 bg-ash-3 rounded" />
      </View>

      {/* Media placeholder */}
      <View className="mx-4 mt-2 h-48 bg-ash-3 rounded-xl" />

      {/* Actions */}
      <View className="flex-row justify-between items-center px-6 py-3 mt-2 border-t border-ash-3">
        <View className="h-3 w-20 bg-ash-3 rounded" />
        <View className="h-3 w-24 bg-ash-3 rounded" />
      </View>
      <View className="flex-row justify-between px-6 py-3 border-t border-ash-3">
        <View className="h-6 w-16 bg-ash-3 rounded" />
        <View className="h-6 w-16 bg-ash-3 rounded" />
        <View className="h-6 w-16 bg-ash-3 rounded" />
        <View className="h-6 w-16 bg-ash-3 rounded" />
      </View>

      {/* Comments section */}
      <View className="px-4 pt-3">
        <View className="h-3 w-24 bg-ash-3 rounded mb-4" />
        {Array.from({ length: 3 }).map((_, index) => (
          <View key={index} className="flex-row items-start mb-4">
            <View className="w-9 h-9 rounded-full bg-ash-3 mr-3" />
            <View className="flex-1">
              <View className="h-3 w-24 bg-ash-3 rounded mb-2" />
              <View className="h-3 w-full bg-ash-3 rounded mb-1" />
              <View className="h-3 w-3/4 bg-ash-3 rounded" />
            </View>
          </View>
        ))}
      </View>
    </Animated.View>
  );
};

export default PostDetailSkeleton;
